import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

export class SharedService {
	public api: string = environment.api;
	protected _http: HttpClient;

	constructor(http: HttpClient) {
		this._http = http;
	}
}
export function hasSpecialChars(str: string): boolean {
	const pattern = new RegExp(/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/); // unacceptable chars
	return pattern.test(str);
}
export function isInvalidEmail(email: string): boolean {
	const pattern = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
	return !pattern.test(String(email).toLowerCase());
}
export function isNullOrEmpty(str: string): boolean {
	return (str == null || str.trim() === '');
}
